/*
 * AdminDashboard Messages
 *
 * This contains all the text for the AdminDashboard component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.AdminDashboard';

export default defineMessages({
  tableTitle: {
    id: `${scope}.tableTitle`,
    defaultMessage: 'Users',
  },
  searchUser: {
    id: `${scope}.searchUser`,
    defaultMessage: 'Search user',
  },
  updateSuc: {
    id: `${scope}.updateSuc`,
    defaultMessage: 'User updated successfully',
  },
  updateUser: {
    id: `${scope}.updateUser`,
    defaultMessage: 'Update user',
  },
  createUser: {
    id: `${scope}.createUser`,
    defaultMessage: 'Create user',
  },
  deactivateSuc: {
    id: `${scope}.deactivateSuc`,
    defaultMessage: 'User is deactivated successfully',
  },
  transferAndDeacSuc: {
    id: `${scope}.transferAndDeacSuc`,
    defaultMessage:
      'Ownership has been transferred and user is deactivated successfully',
  },
  transferSuc: {
    id: `${scope}.transferSuc`,
    defaultMessage: 'Ownership has been transferred successfully',
  },
  activateSuc: {
    id: `${scope}.activateSuc`,
    defaultMessage: 'User is activated successfully',
  },
  confirmDeactivate: {
    id: `${scope}.confirmDeactivate`,
    defaultMessage: 'Deactivate the user?',
  },
  confirmActivate: {
    id: `${scope}.confirmActivate`,
    defaultMessage: 'Activate the user',
  },
  deactivateInfo: {
    id: `${scope}.deactivateInfo`,
    defaultMessage: 'Once deactivated, user will not be able to login. ',
  },
  noMatch: {
    id: `${scope}.noMatch`,
    defaultMessage: 'Sorry, no matching users found',
  },
  role: {
    id: `${scope}.role`,
    defaultMessage: 'Role',
  },
  GlobalAdmin: {
    id: `${scope}.GlobalAdmin`,
    defaultMessage: 'Super Administrator',
  },
  Admin: {
    id: `${scope}.Admin`,
    defaultMessage: 'Admin',
  },
  AllOnboarder: {
    id: `${scope}.AllOnboarder`,
    defaultMessage: 'All onboarder',
  },
  WalkerOnboarder: {
    id: `${scope}.WalkerOnboarder`,
    defaultMessage: 'Walker onboader',
  },
  SupporterOnboarder: {
    id: `${scope}.SupporterOnboarder`,
    defaultMessage: 'Supporter onboarder',
  },
  GlobalAdminHint: {
    id: `${scope}.GlobalAdminHint`,
    defaultMessage: 'All read, write, create and delete permissions',
  },
  AdminHint: {
    id: `${scope}.AdminHint`,
    defaultMessage:
      'All read, write, create and delete permissions except the user',
  },
  AllOnboarderHint: {
    id: `${scope}.AllOnboarderHint`,
    defaultMessage: 'Allow both walker and supporter onboarding',
  },
  WalkerOnboarderHint: {
    id: `${scope}.WalkerOnboarderHint`,
    defaultMessage: 'Allow only walker onboarding',
  },
  SupporterOnboarderHint: {
    id: `${scope}.SupporterOnboarderHint`,
    defaultMessage: 'Allow only supporter onboarding',
  },
  ReadOnly: {
    id: `${scope}.ReadOnly`,
    defaultMessage: 'Read only',
  },
  ReadOnlyHint: {
    id: `${scope}.ReadOnlyHint`,
    defaultMessage: 'Allow only read access to all data and dashboards',
  },
  Volunteer: {
    id: `${scope}.Volunteer`,
    defaultMessage: 'Volunteer',
  },
  VolunteerHint: {
    id: `${scope}.VolunteerHint`,
    defaultMessage: 'Users that manage the onboarding of the D-day',
  },
  ExternalClub: {
    id: `${scope}.ExternalClub`,
    defaultMessage: 'External club',
  },
  ExternalClubHint: {
    id: `${scope}.ExternalClubHint`,
    defaultMessage: 'External club representatives',
  },
});
